export default __webpack_public_path__ + "static/media/faithImage3Small.b42115b4.jpg";